// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3Xn8f","head":"ProcedureTableInfo_head__2KBak"};